import React, { useEffect, lazy, Suspense, useRef, useState } from "react";
import MainMixAndMatch from "../MixAndMatch/MainMixAndMatch";
import AddMixAndMatchDeal from "../MixAndMatch/AddMixAndMatchDeal";
import UpdateMixAndMatchDeal from "../MixAndMatch/UpdateMixAndMatchDeal";
import MainSalesReport from "../Reporting/SalesReport/MainSalesReport";
import NewSalesReportMain from "../SalesReport/NewSalesReportMain";
import { CircularProgress } from "@mui/material";
import { useSelector } from "react-redux";
import { useAuthDetails } from "../../Common/cookiesHelper";
import { PERMISSIONS } from "../../Constants/permission";
import CreateGroup from "../StoreSetting/CreateGroup/CreateGroup";
import StoreGroups from "../StoreSetting/CreateGroup/StoreGroups";
import {
  hasStoreUrlPermission,
  isLotteryEbtAllowed,
} from "../../helperFunctions/storePermissionHelper";
import PermissionDeniedEmptyState from "../../reuseableComponents/PermissionDeniedEmptyState";
import ResponsiveScope from "../../reuseableComponents/ResponsiveScope/ResponsiveScope";
import { LUMANA_SUPERADMIN_ONLY } from "../lumanaConnect/lumanaFormat";
import { BULK_SETTINGS_SUPERADMIN_ONLY } from "../BulkStoreSettings/bulkSettingsAccess";
import { DEPOSIT_SUPERADMIN_ONLY } from "../ContainerDeposit/depositApi";
import { consumeScrollRestorationClaim } from "../../Common/scrollRestoration";

const MerchantInventoryExport = lazy(
  () => import("../InventoryExport/MerchantInventoryExport")
);

const CurrentInventoryValueOld = lazy(
  () => import("../Reporting/CurrentInventoryValue/CurrentInventoryValueOld")
);
const DropCashMain = lazy(() => import("../Reporting/DropCash/DropCashMain"));
const CompositeItemsMain = lazy(() => import("../CompositeItems/CompositeItemsMain"));
const CompositeOperationsMain = lazy(() => import("../CompositeItems/CompositeOperationsMain"));
const ContainerDepositMain = lazy(() => import("../ContainerDeposit/ContainerDepositMain"));
const ProductLookupsMain = lazy(() => import("../NewInventory/ProductLookups/ProductLookupsMain"));
const PayInMain = lazy(() => import("../Reporting/PayIn/PayInMain"));
const MainEmployeeSalesPerCategory = lazy(
  () =>
    import("../Reporting/EmployeeSalesPerCategory/MainEmployeeSalesPerCategory")
);
const MainGiftCard = lazy(() => import("../Reporting/GiftCard/MainGiftCard"));
const InventoryMerge = lazy(() => import("../Products/InventoryMerge"));
const ZohoConnectPage = lazy(
  () => import("../../Components/zohoConnect/zohoConnect")
);
const HqConnectPage = lazy(() => import("../../Components/hqConnect/HqConnect"));
const LumanaConnectPage = lazy(() => import("../../Components/lumanaConnect/LumanaConnect"));
const QuickBooksPage = lazy(() => import("../../Components/quickbooks/QuickBooks"));
const DashboardMain = lazy(() => import("../Dashboard/NewDashboardMain"));
const NodeDashboardMain = lazy(
  () => import("../node_Dashboard/NewDashboardMain")
);
const OldDashboard = lazy(() => import("../Dashboard/DashboardMain"));
const MainOrder = lazy(() => import("../Orders/MainOrder"));
const MainOrderNewUI = lazy(() => import("../OrdersNewUI/MainOrder"));
const MainAttributes = lazy(() => import("../Attributes/MainAttributes"));
const ProductEdit = lazy(() => import("../Products/ProductEdit"));
const MainVendors = lazy(() => import("../Vendors/MainVendors"));
const NewVendors = lazy(() => import("../Vendors/newVendors"));
const MainTimesheet = lazy(() => import("../Timesheet/MainTimesheet"));
const NewMainTimesheet = lazy(() => import("../Timesheet/NewMainTimesheet"));
const DailyReviewMain = lazy(
  () => import("../Timesheet/DailyReviewMain/DailyReviewMain")
);
const PayPeriodReview = lazy(
  () => import("../Timesheet/PayPeriodReview/PayPeriodReview")
);
const SummariesMain = lazy(() => import("../Timesheet/Summaries/Summaries"));
const NewTimesheetMain = lazy(
  () => import("../NewTimesheet/NewTimesheetMain")
);
const MainImportData = lazy(() => import("../ImportData/MainImportData"));
const AskQuickveeAI = lazy(() => import("../AskQuickveeAI/AskAI"));
const MainProducts = lazy(() => import("../Products/MainProducts"));
const BulkProductUpdateMain = lazy(
  () => import("../BulkProductUpdate/BulkProductUpdateMain")
);
const MainStoreOption = lazy(
  () => import("../StoreSetting/StoreOption/MainStoreOption")
);
const EditCategory = lazy(() => import("../Category/EditCategory"));
const TopTenders = lazy(() => import("../Dashboard/TopTenders"));
const Info = lazy(() => import("../StoreSetting/Info"));
const ZohoProductMapping = lazy(
  () => import("../StoreSetting/zohoProductMapping")
);
const Setup = lazy(() => import("../StoreSetting/MainSetup/Setup"));
const MainStoreAlters = lazy(
  () => import("../StoreSetting/StoreAlters/MainStoreAlters")
);
const MainTaxes = lazy(() => import("../StoreSetting/Taxes/MainTaxes"));
const MainInventory = lazy(
  () => import("../StoreSetting/Inventory/MainInventory")
);
const MainResigtersetting = lazy(
  () => import("../StoreSetting/ResigterSetting/MainResigtersetting")
);
const MainSyastemAccess = lazy(
  () => import("../StoreSetting/SystemAccess/MainSystemAccess")
);
const DailyTtlReport = lazy(
  () => import("../Reporting/DailyReport/DailyTtlReport")
);
const MainCatedetails = lazy(
  () => import("../Reporting/CategoryDetails/MainCatedetails")
);
const MainSalesPerson = lazy(
  () => import("../Reporting/SalesByPerson/MainSalesPerson")
);
const CheckIDVerifyMain = lazy(
  () => import("../Reporting/CheckIDVerify/CheckIDVerifyMain")
);
const InstantActvity = lazy(
  () => import("../Reporting/InstantPo/InstantActvity")
);
const TopSallerReport = lazy(
  () => import("../Reporting/TopSaller/TopSallerReport")
);
const EmployeeWorking = lazy(
  () => import("../Reporting/EmployeeWorkingHours/EmployeeWorking")
);
const EmployeeRatingsReportMain = lazy(
  () => import("../Reporting/EmployeeRatingsReport/EmployeeRatingReportMain")
);
const MainSiftSummary = lazy(
  () => import("../Reporting/SiftSummary/MainSiftSummary")
);
const PaymentMethodReport = lazy(
  () => import("../Reporting/PaymentMehodDetail/PaymentMethodReport")
);
const MainItem = lazy(() => import("../Reporting/ItemType/MainItem"));
const MainTaxesReport = lazy(
  () => import("../Reporting/Taxes/MainTaxesReport")
);
const NewMainTaxesReport = lazy(
  () => import("../Reporting/NewTaxesReport/MainTaxesReport")
);
const CurrentInventoryValue = lazy(
  () => import("../Reporting/CurrentInventoryValue/CurrentInventoryValue")
);
const MainAddEmployee = lazy(
  () => import("../StoreSetting/AddEmployee/MainAddEmployee")
);
const EmployeePermissionPresetMain = lazy(
  () => import("../StoreSetting/PermissionPreset/PermissionPresetMain")
);
const AddEditEmployeePermissionPreset = lazy(
  () => import("../StoreSetting/PermissionPreset/AddEditPermissionPreset")
);
const ReceiptMainpage = lazy(
  () => import("../StoreSetting/Receipt/ReceiptMainpage")
);
const MainItemSales = lazy(
  () => import("../Reporting/ItemSales/MainItemSales")
);
const NewMainItemSales = lazy(
  () => import("../Reporting/NewItemsales/NewMainItemSales")
);
const NewItemCreatedBetweenMain = lazy(
  () => import("../Reporting/NewItemCreatedBetween/NewItemCreatedBetweenMain")
);
const Permission = lazy(() => import("../StoreSetting/AddEmployee/Permission"));
const OrderSummaryDetails = lazy(
  () =>
    import(
      "../Reporting/SalesByPerson/MainOrderSumaaryDetails/OrderSummaryDetails"
    )
);
const VendorListMain = lazy(
  () => import("../Reporting/VendorList/VendorListMain")
);
const VendorSalesReportMain = lazy(
  () => import("../Reporting/VendorSalesReport/VendorSalesReportMain")
);
const OrderRefundReportMain = lazy(
  () => import("../Reporting/OrderRefundReport/OrderRefundReportMain")
);
const ReorderInventoryMain = lazy(
  () => import("../Reporting/ReorderInventory/ReorderInventoryMain")
);
const EditVendors = lazy(() => import("../Vendors/EditVendors"));
const SingleVendorsDetail = lazy(
  () => import("../Vendors/SingleVendorsDetail")
);
const NewVendorDetail = lazy(() => import("../Vendors/NewVendorDetail"));
const AddProducts = lazy(() => import("../Products/AddProducts"));
const MainLoayalty = lazy(() => import("../LoyaltyProgram/MainLoayalty"));
const MainEmployeelist = lazy(
  () => import("../Reporting/Employelist/MainEmployeelist")
);
const EditCoupon = lazy(() => import("../Coupons/EditCoupon"));
const StorePage = lazy(() => import("../Store/MerchantStore"));
const ManagerStore = lazy(() => import("../Store/ManagerStore"));
const ProductSalesReport = lazy(() => import("../Products/ProductSalesReport"));
const TipReportMain = lazy(
  () => import("../Reporting/TipReport/TipReportMain")
);
const CouponReportMain = lazy(
  () => import("../Reporting/CouponReport/CouponReportMain")
);
const SalesReportMain = lazy(
  () => import("../Reporting/SalesReport/SalesReportMain")
);
const Discount_Per_Sales = lazy(
  () => import("../Reporting/Discount_Per_Sales/discount_per_sales")
);
const Items_sales_profit_record = lazy(
  () => import("../Reporting/itemSalesProfitRecord/items_sales_profit_record")
);
const RefundSummary = lazy(
  () => import("../Reporting/RefundSummary/RefundSummary")
);
const InventoryList = lazy(
  () => import("../Reporting/inventoryList/inventoryList")
);
const ProfitMarginReport = lazy(
  () => import("../Reporting/ProfitMarginReport/profitMarginReport")
);
const AddNewStocktakeNew = lazy(
  () => import("../Stocktake/AddNewStocktakeNew")
);
const StocktakeList = lazy(() => import("../Stocktake/StocktakeList"));
const StocktakeAppPage = lazy(() => import("../NewStocktake"));
const StocktakeSessionPage = lazy(
  () => import("../NewStocktake/StocktakeSessionPage"),
);
const StocktakeReport = lazy(() => import("../Stocktake/StocktakeReport"));
const InventoryTransferPage = lazy(() =>
  import("../InventoryTransfer/InventoryTransferPage")
);
const AddCategory = lazy(() => import("../Category/AddCategory"));
const AddCoupon = lazy(() => import("../Coupons/AddCoupon"));
const AddVendors = lazy(() => import("../Vendors/AddVendors"));
const NeedHelp = lazy(() => import("../NeedHelp/NeedHelp"));
const Brands = lazy(() => import("../Brands/MainBrand"));
const Tags = lazy(() => import("../Tags/MainTags"));
const NewCategoryPage = lazy(() => import("../NewInventory/NewCategory"));
const NewBrandsPage = lazy(() => import("../NewInventory/NewBrands"));
const NewTagsPage = lazy(() => import("../NewInventory/NewTags"));
const NewAttributesPage = lazy(() => import("../NewInventory/NewAttributes"));
const NewAuditLogPage = lazy(() => import("../NewInventory/NewAuditLog"));
const NewStockOnHandPage = lazy(() =>
  import("../NewInventory/StockOnHand/NewStockOnHand")
);
const NewProductsPage = lazy(() => import("../NewInventory/NewProducts"));
const NewVariantsPage = lazy(() => import("../NewInventory/NewVariants"));
const NewProductFormPage = lazy(() => import("../NewInventory/NewProductForm"));
const NewSalesHistoryPage = lazy(() => import("../NewInventory/NewSalesHistory"));
const NewPurchaseOrderPage = lazy(() =>
  import("../NewPurchaseOrder/NewPurchaseOrder")
);
const AddNewPurchaseOrderPage = lazy(() =>
  import("../NewPurchaseOrder/AddPurchaseOrder")
);
const NewPurchaseOrderDetailPage = lazy(() =>
  import("../NewPurchaseOrder/PurchaseOrderDetail")
);
const CategorySalesSummeryReport = lazy(
  () =>
    import("../Reporting/CategorySalesSummeryReport/categorySalesSummeryMain")
);
const SalesByHoursReport = lazy(
  () => import("../Reporting/SalesByHourReport/SalesByHourMain")
);
const MainDigitalMarketing = lazy(
  () => import("../StoreSetting/DigitalMarketing/MainDigitalMarketing")
);
const StoreCreditReportMain = lazy(
  () => import("../Reporting/StoreCreditReport/StoreCreditReportMain")
);
const DetailedLoyaltyPointReportMain = lazy(
  () =>
    import(
      "../Reporting/DetailedLoyaltyPointReport/DetailedLoyaltyPointReportMain"
    )
);
const NewCustomersAddedReportMain = lazy(
  () =>
    import("../Reporting/NewCustomerAddedReport/NewCustomersAddedReportMain")
);
const RegisterClosuresMain = lazy(
  () => import("../Reporting/RegisterClosures/RegisterActivityMain")
);
const RegisterClosuresSummery = lazy(
  () => import("../Reporting/RegisterClosures/RegisterClosureSummery")
);

const RegisterClosuresTransactions = lazy(
  () => import("../Reporting/RegisterClosures/RegisterClosureTransactions")
);

const MainLoyaltyProgramPage = lazy(
  () => import("../StoreSetting/LoyaltyProgram/MainLoyaltyProgram")
);
const NewLoyaltyProgramPage = lazy(
  () => import("../LoyaltyProgram2/LoyaltyProgram")
);
const MainLotteryReport = lazy(
  () => import("../Reporting/LotteryPayoutReport/LotteryPayoutMain")
);
const LotteryMain = lazy(() => import("../Lottery/LotteryMain"));
const AddLottery = lazy(() => import("../Lottery/AddLottery"));
const DashboardChartViewReports = lazy(
  () => import("../Dashboard/DashboardChartViewReports")
);
const NodeDashboardChartViewReports = lazy(
  () => import("../node_Dashboard/DashboardChartViewReports")
);
const PaymentViewReports = lazy(
  () => import("../Reporting/PaymentReport/PaymentReportMain")
);
const RefundReportMain = lazy(
  () => import("../Reporting/Refund Report/RefundReportMain")
);
const MainInventoryReport = lazy(
  () => import("../Reporting/InventoryReport/MainInventoryReport")
);
const PayInsAndPayoutReport = lazy(
  () => import("../Reporting/RegisterClosures/PayInsAndPayout")
);
const CustomerReportMain = lazy(
  () => import("../Reporting/CustomerReport/CustomerReportMain")
);
const EmployeeReportMain = lazy(
  () => import("../Reporting/EmployeeReport/EmployeeReportMain")
);
const CustomerMain = lazy(() => import("../Customer/CustomerMain"));
const CustomerManagementMain = lazy(() => import("../CustomerManagement/CustomerManagementMain"));
const AddNewCustomerDashboard = lazy(
  () => import("../Customer/AddNewCustomer")
);
const ViewCustomerDashboard = lazy(() => import("../Customer/ViewCustomer"));
const OldSalseSummery = lazy(
  () => import("../Reporting/Old Salse Summery/OldSalesReportMain")
);
const TimeSheetSummeryTable = lazy(
  () => import("../../Components/Timesheet/Summaries/tableSummery")
);
const BogoListing = lazy(() => import("../Bogo/BogoListing"));
const AddEditBogo = lazy(() => import("../Bogo/AddAndEditBogo"));
const ProductAndCategoryDiscountsMain = lazy(
  () => import("../ProductAndCategoryDiscounts/ProductAndCategoryDiscountsMain")
);
const ProductAndCategoryDiscountsAddEdit = lazy(
  () =>
    import(
      "../ProductAndCategoryDiscounts/AddAndEditProductAndCategoryDiscount"
    )
);
const MainNewCoupon = lazy(() => import("../NewCoupons/MainNewCoupon"));
const AddOrderCoupon = lazy(
  () => import("../NewCoupons/OrderCoupon/AddOrderCoupon")
);
const EditOrderCoupon = lazy(
  () => import("../NewCoupons/OrderCoupon/EditOrderCoupon")
);
const AddItemCoupon = lazy(
  () => import("../NewCoupons/ItemCoupon/AddItemCoupon")
);
const EditItemCoupon = lazy(
  () => import("../NewCoupons/ItemCoupon/EditItemCoupon")
);
const BreaksAndCompliance = lazy(
  () => import("../StoreSetting/BreaksAndCompliance/BreaksAndCompliance")
);
const BulkStoreSettingsMain = lazy(
  () => import("../BulkStoreSettings/BulkStoreSettingsMain")
);
const MainScanData = lazy(
  () => import("../StoreSetting/ScanData/MainScanData")
);

const ManageEmployeeMain = lazy(
  () => import("../StoreSetting/ManageEmployee/ManageEmployeeMain")
);
const ManageEmployeePermissions = lazy(
  () => import("../StoreSetting/ManageEmployee/ManagePermissions")
);
const UberReportsMain = lazy(
  () => import("../Reporting/UberReports/UberReportsMain")
);
const CustomerFeedMain = lazy(() => import("../CustomerFeed/CustomerFeedMain"));
const GiftCardMain = lazy(() => import("../GiftCard/GiftCardMain"));
const ProductIssuesMain = lazy(() => import("../ProductIssues/ProductIssuesMain"));
const ProductIssuesBadge = lazy(() => import("../ProductIssues/ProductIssuesBadge"));
const LocationReportMain = lazy(
  () => import("../Reporting/LocationReport/LocationReportMain")
);
const SalesItemNewMain = lazy(
  () => import("../Reporting/SalesItemNew/SalesItemNewMain")
);
const SalesItemDataMain = lazy(
  () => import("../Reporting/SalesItemNew/SalesItemDataMain")
);
const CategorySoldReportMain = lazy(
  () => import("../Reporting/SalesItemNew/CategorySoldReportMain")
);
const PoProductsReportMain = lazy(
  () => import("../Reporting/SalesItemNew/PoProductsReportMain")
);
const LeftSide = ({ visible }) => {
  const { permissions, status, error } = useSelector(
    (state) => state.permissions
  );
  const { LoginGetDashBoardRecordJson, LoginAllStore, userTypeData } =
    useAuthDetails();

  // Lottery is always visible in the menu, but the page is accessible only
  // when the EBT flag (store or employee) === 4. This blocks the page for
  // every login type (merchant/superadmin/employee), since permission alone
  // is bypassed for superadmin/merchant.
  const AllInSystemAccessState = useSelector((state) => state.systemAccessList);
  const isLotteryAccessible = isLotteryEbtAllowed(
    LoginGetDashBoardRecordJson?.data?.ebt,
    AllInSystemAccessState?.systemAccessData?.ebt,
  );

  const [activeBlock, setActiveBlock] = useState(false);
  useEffect(() => {
    if (consumeScrollRestorationClaim(window.location.pathname)) return;
    window.scrollTo(0, 0);
  }, [visible]);
  const currentClass = useRef();

  useEffect(() => {
    if (currentClass.current) {
      const computedStyle = window?.getComputedStyle(currentClass.current);
      setActiveBlock(
        computedStyle?.display === "none" &&
        currentClass?.current?.className === "new-dashboard-Android"
      );
    } else {
      setActiveBlock(false);
    }
  }, []);
  const renderComponent = () => {
    const currentPath = window.location.pathname;
    const superadminOnlyVisibles = [
      "addemployee",
      "timesheet",
      "TimeSheet-Summery-Table",
      // The legacy products page ("Old Product") is superadmin-only now; the
      // new UI at /inventory/new-products is the everyday "Product" page.
      //
      // ONLY the listing is gated. product-edit / product-add /
      // duplicate-product / edit-varient stay open because other merchant
      // features deep-link straight into them (Category > View Items, Instant
      // PO report, global search in Header, Store Settings > Synced Products).
      // product-sales is likewise open — the NEW page links to it for Sales
      // history, so gating it would break the page merchants now use.
      "products",
      // Container Deposit: superadmin-only while DEPOSIT_SUPERADMIN_ONLY; after that CNTDT decides below.
      ...(DEPOSIT_SUPERADMIN_ONLY ? ["container-deposit"] : []),
      // Product issues found by the validation worker: superadmin-only.
      "product-issues",
      // Lumana Video: superadmin-only while LUMANA_SUPERADMIN_ONLY.
      ...(LUMANA_SUPERADMIN_ONLY ? ["lumana-connect"] : []),
      // Store Settings > Bulk Update: superadmin-only while BULK_SETTINGS_SUPERADMIN_ONLY;
      // after that STORE_URLS_PERMISSIONS (BULKS) decides for employees.
      ...(BULK_SETTINGS_SUPERADMIN_ONLY ? ["bulk-store-settings"] : []),
    ];
    if (
      superadminOnlyVisibles.includes(visible) &&
      LoginGetDashBoardRecordJson?.login_type !== "superadmin"
    ) {
      return <PermissionDeniedEmptyState />;
    }
    if (!hasStoreUrlPermission(currentPath)) {
      return <PermissionDeniedEmptyState />;
    }
    // Lottery pages: shown in menu but access is gated by the EBT flag.
    const lotteryVisibles = ["lottery", "add-lottery", "update-lottery"];
    if (lotteryVisibles.includes(visible) && !isLotteryAccessible) {
      return <PermissionDeniedEmptyState />;
    }
    // let showOldDashboard = false;
    // let className = showOldDashboard ? "old-dashboard-Android" : "new-dashboard-Android";
    switch (visible) {
      case "dashboard":
        // return <div className="main-dashboard"> {showOldDashboard
        //   ? <div className={className}><OldDashboard /></div>
        //     : <div className={className}><DashboardMain/> </div> } </div>;
        return (
          <div className="main-dashboard">
            {/* Superadmin only. Own request after the home screen mounts; renders nothing until a scanned store has open issues. */}
            {LoginGetDashBoardRecordJson?.login_type === "superadmin" && (
              <Suspense fallback={null}>
                <ProductIssuesBadge />
              </Suspense>
            )}
            {/* <div style={{display:`${!permissions.length || permissions.indexOf( PERMISSIONS.MENU_DASHBOARD_GRAPH) > -1 ? "block":"none"}`}}   ref={currentClass} className="new-dashboard-Android">
              <DashboardMain />{" "}
            </div>
            <div className="old-dashboard-Android">
              <OldDashboard ref={currentClass} activeBlock={activeBlock} />
            </div> */}
            {LoginGetDashBoardRecordJson?.login_type !== "merchant" &&
              LoginGetDashBoardRecordJson?.login_type !== "superadmin" &&
              LoginGetDashBoardRecordJson?.login_type !== "admin" ? (
              <>
                {permissions.length &&
                  permissions.indexOf(PERMISSIONS.MENU_DASHBOARD_GRAPH) > -1 ? (
                  <>
                    <div ref={currentClass} className="new-dashboard-Android">
                      <DashboardMain />{" "}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="old-dashboard-Android">
                      <OldDashboard
                        ref={currentClass}
                        activeBlock={activeBlock}
                      />
                    </div>
                  </>
                )}
              </>
            ) : (
              <div ref={currentClass} className="new-dashboard-Android">
                <DashboardMain />{" "}
              </div>
            )}
          </div>
        );
      case "node-dashboard":
        // return <div className="main-dashboard"> {showOldDashboard
        //   ? <div className={className}><OldDashboard /></div>
        //     : <div className={className}><DashboardMain/> </div> } </div>;
        return (
          <div className="main-dashboard">
            {/* <div style={{display:`${!permissions.length || permissions.indexOf( PERMISSIONS.MENU_DASHBOARD_GRAPH) > -1 ? "block":"none"}`}}   ref={currentClass} className="new-dashboard-Android">
              <DashboardMain />{" "}
            </div>
            <div className="old-dashboard-Android">
              <OldDashboard ref={currentClass} activeBlock={activeBlock} />
            </div> */}
            {LoginGetDashBoardRecordJson?.login_type !== "merchant" &&
              LoginGetDashBoardRecordJson?.login_type !== "superadmin" &&
              LoginGetDashBoardRecordJson?.login_type !== "admin" ? (
              <>
                {permissions.length &&
                  permissions.indexOf(PERMISSIONS.MENU_DASHBOARD_GRAPH) > -1 ? (
                  <>
                    <div ref={currentClass} className="new-dashboard-Android">
                      <NodeDashboardMain />{" "}
                    </div>
                  </>
                ) : (
                  <>
                    <div className="old-dashboard-Android">
                      <OldDashboard
                        ref={currentClass}
                        activeBlock={activeBlock}
                      />
                    </div>
                  </>
                )}
              </>
            ) : (
              <div ref={currentClass} className="new-dashboard-Android">
                <NodeDashboardMain />{" "}
              </div>
            )}
          </div>
        );

      case "dashboard-chart-view-reports":
        return <DashboardChartViewReports />;
      case "node-dashboard-chart-view-reports":
        return <NodeDashboardChartViewReports />;

      case "order":
        return <MainOrder />;
      case "order-online":
        return <MainOrder />;
      case "order-new":
        return <MainOrderNewUI />;
      case "order-online-new":
        return <MainOrderNewUI />;
      case "zoho-connect":
        return <ZohoConnectPage />;
      case "hq-connect":
        return <HqConnectPage />;
      case "lumana-connect":
        return <LumanaConnectPage />;
      case "quickbooks":
        return <QuickBooksPage />;
      case "add-category":
        return <AddCategory />;
      case "new-purchase-order":
        return <NewPurchaseOrderPage />;
      case "new-purchase-order-add":
        return <AddNewPurchaseOrderPage />;
      case "new-purchase-order-detail":
        return <NewPurchaseOrderDetailPage />;
      case "stocktake":
        return <StocktakeList />;
      case "stocktake-app-list":
        return <StocktakeAppPage />;
      case "stocktake-app-session":
        return <StocktakeSessionPage />;
      case "stocktake-updateStocktake":
      case "stocktake-AddStocktake":
        return <AddNewStocktakeNew />;
      case "stocktake-void":
      case "stocktake-completed":
        return <StocktakeReport />;
      case "old-attributes":
        return <MainAttributes />;
      case "products":
        return <MainProducts />;
      case "bulk-product-update":
        return (
          <ResponsiveScope fullBleed>
            <BulkProductUpdateMain />
          </ResponsiveScope>
        );
      case "inventory-transfer":
        return <InventoryTransferPage />;
      case "composite-items":
        return <CompositeItemsMain />;
      case "composite-operations":
        return <CompositeOperationsMain />;
      case "container-deposit":
        return <ContainerDepositMain />;
      case "product-lookups":
        return <ProductLookupsMain />;
      case "store":
        return <StorePage />;
      case "manager":
        return <ManagerStore />;
      case "add-coupons":
        return <AddCoupon />;
      case "coupons-edit-cop":
        return <EditCoupon />;

      case "order-coupons":
        return <MainNewCoupon />;
      case "add-order-coupons":
        return <AddOrderCoupon />;
      case "order-coupons-edit-cop":
        return <EditOrderCoupon />;
      case "item-coupons":
        return <MainNewCoupon />;
      case "add-item-coupons":
        return <AddItemCoupon />;
      case "item-coupons-edit-cop":
        return <EditItemCoupon />;
      case "mix-and-match":
        return <MainMixAndMatch />;
      case "bogo-pricing":
        return <BogoListing />;
      case "bogo-pricing-add":
        return <AddEditBogo />;
      case "add-mix-and-match":
        return <AddMixAndMatchDeal />;
      case "update-mix-and-match":
        return <UpdateMixAndMatchDeal />;
      case "product-and-category-discounts":
        return <ProductAndCategoryDiscountsMain />;
      case "product-and-category-discounts-add-edit":
        return <ProductAndCategoryDiscountsAddEdit />;
      case "old-vendors":
        return <MainVendors />;
      case "vendors":
        return (
          <ResponsiveScope fullBleed>
            <NewVendors />
          </ResponsiveScope>
        );
      case "add-vendors":
        return <AddVendors />;
      case "timesheet":
        return <MainTimesheet />;
      case "timesheets":
        return <NewMainTimesheet />;
      case "newTimesheet":
        return <NewTimesheetMain />;
      case "TimeSheet-Summery-Table": /////////////////
        return <TimeSheetSummeryTable />;
      case "import-data":
        return <MainImportData />;
      case "ask-quickvee-ai":
        return <AskQuickveeAI />;
      case "Digital-marketing-tags":
        return <MainDigitalMarketing />;
      case "store-setting":
        return <MainStoreOption />;
      case "category-edit-cat":
        return <EditCategory />;
      case "toptraders":
        return <TopTenders />;
      case "productedit":
      case "product-edit":
      case "edit-varient":
      case "duplicate-product":
        return <AddProducts />;
      case "product-add":
        return <AddProducts />;
      case "product-sales":
        return <ProductSalesReport />;
      case "info":
        return <Info />;
      case "zohoProductMapping":
        return <ZohoProductMapping />;
      case "need_help":
        return <NeedHelp />;
      case "setup":
        return <Setup />;
      case "Alters":
        return <MainStoreAlters />;
      case "options":
        return <MainStoreOption />;
      case "taxes":
        return <MainTaxes />;
      case "inventory":
        return <MainInventory />;
      case "register":
        return <MainResigtersetting />;
      case "system-access":
        return <MainSyastemAccess />;
      case "breaks-and-compliance":
        return <BreaksAndCompliance />;
      case "bulk-store-settings":
        return <BulkStoreSettingsMain />;
      case "scan-data-AltriaForm":
      case "scan-data-ReynoldsForm":
      case "scan-data-Dezi":
      case "scan-data-SyncedProducts":
      case "scan-data-SentReports":
      case "scan-data-ManualUpload":
        return <MainScanData />;
      case "store-groups":
        return <StoreGroups />;
      case "create-group":
        return <CreateGroup />;
      case "edit-group":
        return <CreateGroup />;
      case "StoreSettingloyalty-program":
        return <MainLoyaltyProgramPage />;
      case "StoreSettingloyalty-program2":
        return <NewLoyaltyProgramPage />;
      case "daily-total-report":
        return <DailyTtlReport />;
      case "Details-category":
        return <MainCatedetails />;
      case "report-sales-person":
        return <MainSalesPerson />;
      case "id-verification":
        return <CheckIDVerifyMain />;
      case "inventory-list":
        return <InventoryList />;
      case "profit-Margin":
        return <ProfitMarginReport />;
      case "instant-activity":
        return <InstantActvity />;
      case "overall-top":
        return <TopSallerReport />;
      // case "employee-working-hours":
      //   return <EmployeeWorking />;
      case "employee-ratings-report":
        return <EmployeeRatingsReportMain />;
      case "shift-summary":
        return <MainSiftSummary />;
      case "payment-method-details":
        return <PaymentMethodReport />;
      case "order-type":
        return <MainItem />;
      case "taxes-report":
        return <MainTaxesReport />;
      case "new-taxes-report":
        return <NewMainTaxesReport />;
      case "current-inventory-value":
        return <CurrentInventoryValue />;
      // return <CurrentInventoryValueOld />;
      case "discount-per-sales-person":
        return <Discount_Per_Sales />;
      case "item-sales-profit-report":
        return <Items_sales_profit_record />;
      case "addemployee":
        return <MainAddEmployee />;
      case "manage-employees":
        return <ManageEmployeeMain />;
      case "manage-employee-permissions":
        return <ManageEmployeePermissions />;
      case "permission-presets":
        return <EmployeePermissionPresetMain />;
      case "permission-presets-add":
        return <AddEditEmployeePermissionPreset />;
      case "permission-presets-edit":
        return <AddEditEmployeePermissionPreset />;
      case "employee-list":
        return <MainEmployeelist />;

      case "dashboard-customer":
        return <CustomerMain />;
      case "dashboard-customer-addCustomer":
        return <AddNewCustomerDashboard />;
      case "dashboard-customer-editCustomer":
        return <AddNewCustomerDashboard />;
      case "dashboard-customer-viewCustomer":
        return <ViewCustomerDashboard />;
      case "customer-management":
        return <CustomerManagementMain />;
      case "receipt":
        return <ReceiptMainpage />;
      case "item-sales":
        return <MainItemSales />;
      case "new-item-sales-report":
        return <NewMainItemSales />;
      case "item-create-between":
        return <NewItemCreatedBetweenMain />;
      case "permission":
        return <Permission />;
      case "order-summary":
        return <OrderSummaryDetails />;
      case "vendors-list":
        return <VendorListMain />;
      case "edit-vendor":
        return <EditVendors />;
      case "vendor-details":
        return <SingleVendorsDetail />;
      case "new-vendor-details":
        return (
          <ResponsiveScope fullBleed>
            <NewVendorDetail />
          </ResponsiveScope>
        );
      case "loyalty-program":
        return <MainLoayalty />;
      case "recorder-inventory":
        return <ReorderInventoryMain />;
      case "vendors-sales-reports":
        return <VendorSalesReportMain />;
      case "order-refund-report":
        return <OrderRefundReportMain />;
      case "pay-ins-and-payout":
        return <PayInsAndPayoutReport />;
      case "refund-report":
        return <RefundSummary />;
      case "tip-report":
        return <TipReportMain />;
      case "coupon-report":
        return <CouponReportMain />;
      case "register-closures":
        return <RegisterClosuresMain />;
      case "register-closures-summery":
        return <RegisterClosuresSummery />;
      case "register-closures-transactions":
        return <RegisterClosuresTransactions />;
      case "refund-report-main":
        return <RefundReportMain />;
      case "drop-cash-report":
        return <DropCashMain />;
      //added
      case "inventory-report":
        return <MainInventoryReport />;
      case "customer-reports":
        return <CustomerReportMain />;
      case "employee-reports":
        return <EmployeeReportMain />;
      case "pay-in-report":
        return <PayInMain />;
      case "sales-report":
        return <SalesReportMain />;
      case "new-sales-report":
        return <NewSalesReportMain />;
      case "lottery-payout-report":
        return <MainLotteryReport />;
      case "old-brands":
        return <Brands />;
      case "old-tags":
        return <Tags />;
      case "category":
        return (
          <ResponsiveScope fullBleed>
            <NewCategoryPage />
          </ResponsiveScope>
        );
      case "stock-on-hand":
        return (
          <ResponsiveScope fullBleed>
            <NewStockOnHandPage />
          </ResponsiveScope>
        );
      case "brands":
        return (
          <ResponsiveScope fullBleed>
            <NewBrandsPage />
          </ResponsiveScope>
        );
      case "tags":
        return (
          <ResponsiveScope fullBleed>
            <NewTagsPage />
          </ResponsiveScope>
        );
      case "attributes":
        return (
          <ResponsiveScope fullBleed>
            <NewAttributesPage />
          </ResponsiveScope>
        );
      case "audit-log":
        return (
          <ResponsiveScope fullBleed>
            <NewAuditLogPage />
          </ResponsiveScope>
        );
      case "new-products":
        return (
          <ResponsiveScope fullBleed>
            <NewProductsPage />
          </ResponsiveScope>
        );
      case "variants":
        return (
          <ResponsiveScope fullBleed>
            <NewVariantsPage />
          </ResponsiveScope>
        );
      case "new-product-add":
      case "new-product-edit":
      case "new-product-duplicate":
        return (
          <ResponsiveScope fullBleed>
            <NewProductFormPage />
          </ResponsiveScope>
        );
      case "new-product-sales":
        return (
          <ResponsiveScope fullBleed>
            <NewSalesHistoryPage />
          </ResponsiveScope>
        );
      /* The three lottery screens ship their own phone layout (lottery.css)
         and are marked data-mwskip, so ResponsiveScope is here only for the
         full-bleed gutter removal the other inventory screens get. */
      case "lottery":
        return (
          <ResponsiveScope fullBleed>
            <LotteryMain />
          </ResponsiveScope>
        );
      case "add-lottery":
      case "update-lottery":
        return (
          <ResponsiveScope fullBleed>
            <AddLottery />
          </ResponsiveScope>
        );
      case "category-sales-summery-report":
        return <CategorySalesSummeryReport />;
      case "sales-by-hour-report":
        return <SalesByHoursReport />;
      case "store-credit-report":
        return <StoreCreditReportMain />;
      case "detailed-loyalty-points-report":
        return <DetailedLoyaltyPointReportMain />;
      case "gift-card-report":
        return <MainGiftCard />;
      case "payment-report":
        return <PaymentViewReports />;
      case "inventory-export-merchant":
        return <MerchantInventoryExport />;
      case "employee-sales-per-category-report":
        return <MainEmployeeSalesPerCategory />;
      case "inventory-merge":
        return <InventoryMerge />;
      case "new-customers-added-report":
        return <NewCustomersAddedReportMain />;
      case "uber-reports":
        return <UberReportsMain />;
      case "customer-feed":
        return <CustomerFeedMain />;
      case "gift-card":
        return <GiftCardMain />;
      case "product-issues":
        return <ProductIssuesMain />;
      case "location-report":
        return hasStoreUrlPermission("/merchants/store-reporting/location-report")
          ? <LocationReportMain />
          : <PermissionDeniedEmptyState />;
      case "item-sold-report":
        return hasStoreUrlPermission("/merchants/store-reporting/item-sold-report")
          ? <SalesItemNewMain />
          : <PermissionDeniedEmptyState />;
      case "category-sold-report":
        return hasStoreUrlPermission("/merchants/store-reporting/category-sold-report")
          ? <CategorySoldReportMain />
          : <PermissionDeniedEmptyState />;
      case "po-products-report":
        return hasStoreUrlPermission("/merchants/store-reporting/po-products-report")
          ? <PoProductsReportMain />
          : <PermissionDeniedEmptyState />;
      case "item-sold-data":
        return hasStoreUrlPermission("/merchants/store-reporting/item-sold-data")
          ? <SalesItemDataMain />
          : <PermissionDeniedEmptyState />;
      case "new-sale-report":
        return <NewSalesReportMain />;
      case "old-sales-summery":
        return <OldSalseSummery />;
      default:
        return <DashboardMain />;
    }
  };

  return (
    <Suspense
      fallback={
        <div>
          <CircularProgress
            style={{
              width: "40px",
              height: "40px",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          />
        </div>
      }
    >
      {renderComponent()}
    </Suspense>
  );
};

export default LeftSide;
